"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRadioLabel = exports.StyledRadioInput = exports.StyledRadio = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tappablearea = _interopRequireDefault(require("../../fuse-tappable-area/src/tappablearea"));
var _typography = require("../../fuse-typography-element/src/typography");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var input = _config.stylesConfig.input,
  radioLabelBefore = _config.stylesConfig.radioLabelBefore;
var StyledRadio = exports.StyledRadio = _styledComponents["default"].div.attrs({
  className: 'fuse-radio'
}).withConfig({
  displayName: "styled-radio__StyledRadio",
  componentId: "sc-9a8fz8-0"
})(["", ""], function (_ref) {
  var fullWidth = _ref.fullWidth,
    marginBottom = _ref.marginBottom,
    marginRight = _ref.marginRight;
  return "\n\t\talign-items: center;\n\t\tdisplay: inline-flex;\n\t\tmargin-bottom: ".concat(marginBottom ? "var(--spacing-global-space6)" : "0", ";\n\t\tmargin-right: ").concat(marginRight ? "var(--spacing-global-space6)" : "0", ";\n\t\tposition: relative;\n\t\twidth: ").concat(fullWidth ? "100%" : "fit-content", ";\n\t");
});
var StyledRadioInput = exports.StyledRadioInput = _styledComponents["default"].input.attrs({
  className: 'fuse-radio__input',
  'data-testid': 'fuse-radio__input'
}).withConfig({
  displayName: "styled-radio__StyledRadioInput",
  componentId: "sc-9a8fz8-1"
})(["appearance:none;background:var(--color-global-grey100);border:3px solid var(--color-global-grey100);border-radius:50%;cursor:pointer;height:", ";left:var(--border-width-s);margin:0;box-shadow:0 0 0 var(--border-width-s) var(--color-functional-divider);position:absolute;width:", ";&:checked{background:var(--color-brand-mid);box-shadow:0 0 0 var(--border-width-s) var(--color-brand-mid);}&:focus-visible{outline-offset:0;}&:focus,&:hover{outline:none;box-shadow:0 0 0 var(--border-width-s) var(--color-brand-dark);}&:focus:checked,&:hover:checked{outline:none;background:var(--color-brand-dark);}&:disabled{cursor:default;box-shadow:0 0 0 var(--border-width-s) var(--color-functional-divider);}&:disabled:checked,&:disabled:focus:checked,&:disabled:hover:checked{background:var(--color-functional-divider);}&:focus-visible + label{", "}&.fuse-radio__input--safari-focus{&:focus-within + label{", "}}"], input.height, input.width, _fuseUtils.FocusCss, _fuseUtils.FocusCss);
var StyledRadioLabel = exports.StyledRadioLabel = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-radio__label',
  'data-testid': 'fuse-radio__label'
}).withConfig({
  displayName: "styled-radio__StyledRadioLabel",
  componentId: "sc-9a8fz8-2"
})(["align-items:center;display:inline-flex;margin:0;cursor:pointer;&[disabled]{color:var(--color-functional-divider);cursor:default;}&::before{content:'';display:inline-block;height:", ";margin-right:var(--spacing-global-space4);min-width:", ";}", ""], radioLabelBefore.height, radioLabelBefore.width, _tappablearea["default"]);